import { Experiments } from 'enums';
import { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { AppStore } from 'stores/App.store';

export const useSaleBannerTitle = (
  appStore: AppStore,
  experiments: InjectedExperimentsProps['experiments'],
): string => {
  const {
    appContext: { isLimitedTimeDiscount },
  } = appStore;

  if (
    isLimitedTimeDiscount ||
    experiments.enabled(Experiments.PREM_1507_30_40_50)
  ) {
    return 'Advanced.Plans_Limited_Time_Offer_sale_banner';
  }
  return 'sale.banner.on.select.plans.text';
};
